import { render, staticRenderFns } from "./description-summary.vue?vue&type=template&id=9f46453c"
import script from "./description-summary.vue?vue&type=script&lang=ts"
export * from "./description-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f46453c')) {
      api.createRecord('9f46453c', component.options)
    } else {
      api.reload('9f46453c', component.options)
    }
    module.hot.accept("./description-summary.vue?vue&type=template&id=9f46453c", function () {
      api.rerender('9f46453c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/description/description-summary.vue"
export default component.exports